module.exports = __webpack_public_path__ + "img/step4.46945c79.png";